import { render, staticRenderFns } from "./mobile-ticket-details.vue?vue&type=template&id=66fcbcab"
import script from "./mobile-ticket-details.vue?vue&type=script&lang=js"
export * from "./mobile-ticket-details.vue?vue&type=script&lang=js"
import style0 from "./mobile-ticket-details.vue?vue&type=style&index=0&id=66fcbcab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports